import React from 'react';
import logo from '../../../assets/images/logo2.png';
import whatsapp from '../../../assets/images/whatsapp.png';
function Footer() {
  return (
    <>
      <div
        id="about"
        className="px-4 pt-16 sm:max-w-xl bg-black border border-black md:max-w-full lg:max-w-full w-screen md:px-24 lg:px-8 box-border"
      >
        <div className="grid gap-10 row-gap-6 mb-0 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <a
              href="/"
              aria-label="Go home"
              title="Company"
              className="inline-flex items-center"
            >
              <img className="w-36" src={logo} />
            </a>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-base font-bold tracking-wide text-gray-200">
              Contacto
            </p>
            <div className="flex">
              <p className="mr-1 text-gray-100">Telefono:</p>
              <a
                href="tel:+5493515395915"
                aria-label="Our phone"
                title="Our phone"
                className="transition-colors duration-300 text-deep-purple-accent-100 hover:text-deep-purple-100 text-blue-500"
              >
                +5493515395915
              </a>
            </div>
            <div className="flex">
              <p className="mr-1 text-gray-100">Email:</p>
              <a
                href="mailto:info@fabrilum.com.ar"
                aria-label="Our email"
                title="Our email"
                className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800 text-blue-500"
              >
                info@fabrilum.com.ar
              </a>
            </div>
            <div className="flex">
              <p className="mr-1 text-gray-100">Direccion:</p>
              <a
                href="https://www.google.com/maps"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Our address"
                title="Our address"
                className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800 text-blue-500"
              >
                Pasaje Peru 4678, Los Boulevares, Cordoba, Argentina
              </a>
            </div>
          </div>
          <div>
            <span className="text-base font-bold tracking-wide text-gray-200">
              Sociales
            </span>
            <div className="flex items-center mt-1 space-x-3">
              <a
                href="https://instagram.com/fabrilum?igshid=MzRlODBiNWFlZA=="
                className="text-gray-300 transition-colors duration-300 hover:text-deep-purple-accent-400"
              >
                <svg viewBox="0 0 30 30" fill="currentColor" className="h-6">
                  <circle cx="15" cy="15" r="4" />
                  <path d="M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10   C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1   c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z" />
                </svg>
              </a>
            </div>
            <p className="mt-4 text-sm text-gray-300"></p>
          </div>
        </div>
      </div>
      <div className="fixed bottom-12 right-4 h-14 w-14 cursor-pointer ">
        <a
          href="https://wa.me/+5493515395915?text=Quiero%20hacer%20un%20pedido"
          target="_blank"
        >
          <img src={whatsapp} />
        </a>
      </div>
    </>
  );
}
export default Footer;
